import styles from './feature_ethical_savings.module.scss'
import { graphql } from 'gatsby'
import PageLayout from '../components/PageLayout/PageLayout'
import FeaturesZoneRenderer from '../zones/FeaturesZoneRenderer'
import { PageHorizontalNav } from '../components/PageHorizontalNav/PageHorizontalNav'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import { VAlign } from '@algbra/ui/enums/align'
import Heading from '@algbra/ui/components/Heading/Heading'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import HeaderContainerEthicalSavings from '../components/HeaderContainerEthicalSavings/HeaderContainerEthicalSavings'
import { useEffect, useState } from 'react'
import axios from 'axios'
import MetaTags from '../components/MetaTags/MetaTags'
import { getMetaTags } from '../utils/metaTags'

export default function LayoutFeaturesEthicalSavings({
  pageContext,
  data,
  location,
}) {
  const [topRate, setTopRate] = useState(null)
  const zones = data.strapiGQL.feature.contentZones

  useEffect(() => {
    axios
      .get('/.netlify/functions/topRate')
      .then(response => {
        setTopRate(response.data)
      })
      .catch(() => {
        setTopRate(null)
      })
  }, [])

  return (
    <PageLayout>
      <MetaTags {...getMetaTags(pageContext)} />
      <PageHorizontalNav parent="features" />
      <HeaderContainerEthicalSavings>
        <Container
          fluid={false}
          className={styles.zIndexed}
          role="complementary"
        >
          <Row vAlign={VAlign.CENTER} className={styles.bannerArea}>
            <Column size={12} sm={12} className={styles.content}>
              <div className={styles.textContainer}>
                <StaticImage
                  src="../images/early-access.png"
                  alt="Algbra Card"
                  layout="constrained"
                  width={88}
                  quality={100}
                  placeholder="blurred"
                  loading="eager"
                  className={styles.earlyAccessImage}
                />
                <Heading level={1} type="xl" className={styles.header}>
                  Earn up to {topRate?.rate?.toFixed(2)}% EPR* on your money
                </Heading>
                <FreeText
                  className={classNames(styles.text, styles.subtitle)}
                  color="white"
                >
                  Ethical. Profitable. Human.
                </FreeText>
              </div>
              <div className={styles.bottomContainer}>
                <div className={styles.fscsContainer}>
                  <div className={styles.fscsWrapper}>
                    <StaticImage
                      src="../images/home/fscs-badge-white.png"
                      alt="FSCS"
                      layout="constrained"
                      width={48}
                      quality={100}
                      placeholder="blurred"
                      loading="eager"
                      className={styles.logo}
                    />
                  </div>
                  <div>
                    <p className={styles.fscsDescription}>
                      <strong>Available to UK residents only.</strong> Funds
                      held in your Ethical Saver Cubes are protected by the FSCS
                      up to £120,000. T&Cs apply.
                    </p>
                  </div>
                </div>
              </div>
            </Column>
          </Row>
        </Container>
      </HeaderContainerEthicalSavings>
      {zones && <FeaturesZoneRenderer zones={zones} />}
    </PageLayout>
  )
}

export const pageQuery = graphql`
  query ($id: ID!) {
    strapiGQL {
      feature(id: $id) {
        ...StrapiGQL_FeaturesWithContentZones
      }
    }
  }
`
